import { useState } from 'react';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotInput = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotInput && honeypotInput.value.trim() !== '') {
      setFormStatus('success');
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    setFormStatus('submitting');

    try {
      const formData = new FormData(form);
      const url = 'https://readdy.ai/api/form/d9lfqle8mbnljin59cjg';

      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const text = await res.text();
      let parsed: { code?: string; meta?: { message?: string } } = {};
      try { parsed = JSON.parse(text); } catch { /* raw text */ }

      if (res.ok && parsed.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 4000);
      } else {
        const msg = parsed?.meta?.message || text || '提交失败';
        if (msg.includes('spam')) {
          setFormStatus('success');
          form.reset();
          setTimeout(() => setFormStatus('idle'), 3000);
        } else {
          setFormError(msg);
          setFormStatus('error');
        }
      }
    } catch {
      setFormError('网络异常，请稍后重试');
      setFormStatus('error');
    }
  };

  return (
    <section id="contact" className="section-padding bg-background-50">
      <div className="section-container max-w-xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            联系我们
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            有爆料线索？有合作意向？欢迎通过下方表单联系我们。
            所有投稿信息严格保密，编辑团队24小时内回复。
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="space-y-4 p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70"
        >
          <div>
            <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
              你的称呼
            </label>
            <input
              id="contact-name"
              name="name"
              type="text"
              required
              className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
              placeholder="请输入你的昵称"
            />
          </div>

          <div>
            <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
              邮箱地址
            </label>
            <input
              id="contact-email"
              name="email"
              type="email"
              required
              className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
              placeholder="your@email.com"
            />
          </div>

          <div>
            <label htmlFor="contact-type" className="block text-sm font-medium text-foreground-700 mb-1.5">
              咨询类型
            </label>
            <select
              id="contact-type"
              name="type"
              required
              className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors cursor-pointer"
            >
              <option value="">请选择</option>
              <option value="tip">投稿爆料</option>
              <option value="appeal">内容申诉</option>
              <option value="cooperation">商务合作</option>
              <option value="other">其他</option>
            </select>
          </div>

          <div>
            <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
              具体内容
            </label>
            <textarea
              id="contact-message"
              name="message"
              required
              maxLength={500}
              rows={4}
              className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
              placeholder="请详细描述你的爆料、申诉或合作需求（500字以内）"
            ></textarea>
            <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
          </div>

          {/* Honeypot */}
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="hp-field"
          />

          <button
            type="submit"
            disabled={formStatus === 'submitting'}
            className="w-full py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors disabled:opacity-60 cursor-pointer whitespace-nowrap"
          >
            {formStatus === 'submitting' ? '提交中...' : '发送信息'}
          </button>

          {formStatus === 'success' && (
            <p className="text-sm text-green-600 text-center">已收到你的信息，我们会尽快处理！</p>
          )}
          {formStatus === 'error' && (
            <p className="text-sm text-red-500 text-center">{formError || '提交失败，请重试'}</p>
          )}
        </form>
      </div>
    </section>
  );
}